import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./pages.css";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./app/store";
import App from "./App";
import './i18n'
import LanguageProvider from './components/language/LanguageProvider'


const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement,
);
root.render(
	<React.StrictMode>
		<Provider store={store}>
			<PersistGate persistor={persistor}>
				<LanguageProvider>
					<App />
				</LanguageProvider>
			</PersistGate>
		</Provider>
	</React.StrictMode>,
);
